import {Injectable, signal} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationsUpdateService {
  private readonly _shouldReload = new Subject<void>();
  readonly shouldReload = this._shouldReload.asObservable();
  private readonly _unreadCount = signal(0);
  readonly unreadCount = this._unreadCount.asReadonly();

  setUnreadCount(count: number) {
    this._unreadCount.set(count);
  }

  shouldReloadNotifications(count: number) {
    this.setUnreadCount(count);
    this._shouldReload.next();
  }

  decreaseUnreadCount() {
    this._unreadCount.update(count => count - 1);
  }

  resetUnreadCount() {
    this._unreadCount.set(0);
  }
}
